import React from "react";
import styled from "styled-components";
import { Link } from 'react-scroll'

import Colors from "../../constants/colors";

const Container = styled.div`
  z-index: 99;
  position: fixed;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  
  ul {
    margin: 0;
  }

  li {
    list-style: none;
    margin:0;
    position: relative;

    &:not(:last-child)::after {
      content: "";
      position: absolute;
      top: calc( 50% + 9px );
      right: 21px;
      width: 1px;
      height: 18px;
      background-color: ${Colors.Basic.gray_88};
    }
  }

`;

const NavItem = styled(Link)`
  position: relative;
  display: block;
  height: 36px;
  padding-right: 36px;
  cursor: pointer;

  div {
    display: none;
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 32px;
    padding: 0 16px;
    border-radius: 16px;
    text-align: right;
    color: ${Colors.Basic.white};
    transition: all 0.25s ease-in-out;
  }

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    right: 18px;
    transform: translateY(-50%);
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: ${Colors.Basic.gray_63};
    z-index: 2;
    transition: all 0.25s ease-in-out;
  }

  &::after {
    content: "";
    position: absolute;
    top: 50%;
    right: 14px;
    transform: translateY(-50%);
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-color: transparent;
    border: 0 solid ${Colors.Basic.orange_01};
    z-index: 2;
    transition: all 0.15s ease-in-out;
  }

  &.active {
    &::before {
      background-color: ${Colors.Basic.orange_01};
    };
  }

  &:hover, &:focus {
    div {
      display: block;
      background-color: ${Colors.Background.section_indicator_text_container};
    }

    &::before {
      background-color: ${Colors.Background.section_indicator_hover};
    }

    &::after {
      border: 2px solid ${Colors.Basic.orange_01};
    }

    &.active {
      &::before {
        background-color: ${Colors.Basic.orange_01};
      };
      &::after {
        border: 2px solid ${Colors.Basic.orange_01};
      }
    }
  }
`;


const SectionIndicator = ({sections}) => {
  return (
    <Container>
      <ul>
        {sections.map(link => (
          <li key={link.name}>
            <NavItem 
              to={link.to}
              activeClass="active"
              spy={true}
              smooth={true}
              duration={800}
              isDynamic={true}
            >
              <div>
                {link.name}
              </div>
            </NavItem>
          </li>
        ))}
      </ul>
    </Container>
  );
};

export default SectionIndicator;